/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assetlibrarypickerlisterror4Inputs */

const en_assetlibrarypickerlisterror4 = /** @type {(inputs: Assetlibrarypickerlisterror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load your library.`)
};

const de_assetlibrarypickerlisterror4 = /** @type {(inputs: Assetlibrarypickerlisterror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Mediathek konnte nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "Could not load your library." |
*
* @param {Assetlibrarypickerlisterror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const assetlibrarypickerlisterror4 = /** @type {((inputs?: Assetlibrarypickerlisterror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assetlibrarypickerlisterror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assetlibrarypickerlisterror4(inputs)
	return de_assetlibrarypickerlisterror4(inputs)
});
export { assetlibrarypickerlisterror4 as "assetLibraryPickerListError" }